// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"1aa2ceb3","703":"8daa458e","787":"74bb51d3"}[chunkId] + ".chunk.js";
};